import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageContainerModule } from '@zelis/platform-ui-components';
import { GuidedSearchBrowseByComponent } from './guided-search-browse-by.component';
import { GuidedSearchTileModule } from '@components/guided-search/guided-search-tile/guided-search-tile.module';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
@NgModule({
  declarations: [GuidedSearchBrowseByComponent],
  imports: [
    CommonModule,
    PageContainerModule,
    GuidedSearchTileModule,
    TranslateModule,
    FlexLayoutModule,
  ],
  exports: [GuidedSearchBrowseByComponent],
})
export class GuidedSearchBrowseByModule {}
